/** Must match backend MAX_UPLOAD_MB (default 50). */
export const MAX_UPLOAD_MB = Number(process.env.REACT_APP_MAX_UPLOAD_MB) || 50;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

export function getUploadSizeError(sizeBytes) {
  if (sizeBytes <= MAX_UPLOAD_BYTES) return null;
  const sizeMb = (sizeBytes / (1024 * 1024)).toFixed(1);
  return `File is ${sizeMb} MB. Maximum upload size is ${MAX_UPLOAD_MB} MB per file.`;
}

/** Parse upload API errors (nginx 413 returns HTML, not JSON). */
export async function getUploadErrorMessage(response) {
  if (response.status === 413) {
    return `Upload rejected: file too large for the server (limit is ${MAX_UPLOAD_MB} MB per file). If the file is smaller, the reverse proxy/nginx on the server must allow at least 64–100 MB (client_max_body_size).`;
  }
  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    try {
      const data = await response.json();
      return data.message || data.error || `Upload failed (${response.status})`;
    } catch (_) {
      /* fall through */
    }
  }
  return `Upload failed (HTTP ${response.status}). The server may have a body-size or proxy limit.`;
}
